export default {
  modalBackground: Styles.color.dialogBackground,
  disclaimerColor: Styles.color.grey.one,
};
